/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/styles/index.scss';

export { default as wrapRootElement } from './wrap-with-provider';

export const onClientEntry = () => {
  window['adrum-start-time'] = new Date().getTime();
  window['adrum-config'] = {
    appKey: process.env.GATSBY_APPDYNAMICS_APPKEY,
    adrumExtUrlHttp: 'http://cdn.appdynamics.com',
    adrumExtUrlHttps: 'https://cdn.appdynamics.com',
    beaconUrlHttp: 'http://syd-col.eum-appdynamics.com',
    beaconUrlHttps: 'https://syd-col.eum-appdynamics.com',
    useHTTPSAlways: true,
    resTiming: { bufSize: 200, clearResTimingOnBeaconSend: true },
    maxUrlLength: 512,
  };
  const script = document.createElement('script');
  script.src = 'https://cdn.appdynamics.com/adrum/adrum-24.4.0.4454.js';
  script.async = true;
  document.head.appendChild(script);
};
